export type TypeSecurityEvent = {
    action?: unknown;
    sessionIds?: unknown;
    keptSid?: unknown;
};

const listOf = (value: unknown): string[] => (Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : []);

export default function securityEventKicks(event: TypeSecurityEvent | null | undefined, ownSid: string | null): boolean {
    if (!event || ownSid === null) return false;
    if (listOf(event.sessionIds).includes(ownSid)) return true;
    return event.action === 'sessions.closed' && typeof event.keptSid === 'string' && event.keptSid !== ownSid;
}
